<template>
  <transition-group name="compose-message" mode="out-in">
    <div key="compose" class="compose-message">
      <div class="compose-message__form">
        <h1 
          :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
          class="h1">Compose Message</h1>
        <form class="form form--inline" @submit.prevent="sendEmail" id="message">
          <div class="form-wrap">
            <module-fieldset
              v-for="(field, key) in fields"
              v-bind="field"
              :id="key"
              :key="key"
            />

            <module-button
              :disabled="!isValid"
              label="Send message"
              :loading="getMessageSending && !getSentStatus"
            />

          </div>
        </form>
      </div>
    </div>
    <ui-module-loader key="loader" @messages-complete="onMessagesComplete" v-if="getSentStatus" :messages="['Message sent', 'Please allow up to 2 working days for a response']" />
  </transition-group>
</template>

<script>
// Vuex
import { mapGetters, mapActions } from 'vuex';

import UiModuleLoader from 'components/ModuleLoader';


export default {
  name: 'module-compose-message',

  // Components
  components: {
    UiModuleLoader,
  },

  // Data
  data() {
    return {
      fields: {
        subject: {
          type: 'text',
          label: 'Subject',
          required: true,
          placeholder: 'Subject',
        },
        message: {
          type: 'textarea',
          label: 'Message Body',
          placeholder: 'Message Body',
          required: true,
        },
        files: {
          type: 'file',
          label: 'File upload',
          required: false,
          accept: ['jpg', 'jpeg', 'gif', 'png', 'pdf', 'docx', 'csv', 'xls', 'txt', 'doc', 'xlsx'],
        },
      },
      email: '',
      sendingMessage: false,
    };
  },

  computed: {
    ...mapGetters('messaging', ['getSelectedContact', 'getSelectedMessage', 'getMessageSending', 'getSentStatus']),
    ...mapGetters('forms', ['getFieldModel']),
    ...mapGetters('app', ['org']),

    replyingToMessage() {
      return localStorage.getItem('messageSubject');
    },

    isValid() {
      return this.getFieldModel('global|message');
    },

  },

  methods: {
    ...mapActions('messaging', ['requestSendMessage', 'requestContactById', 'sendDocument', 'clearMessagingStore']),


    sendEmail() {
      const emailModel = {
        'to_id': this.getSelectedContact.id,
      };

      _.forEach(this.fields, (value, key) => { // eslint-disable-line no-undef
        emailModel[key] = this.getFieldModel(`global|${key}`);
      });

      this.requestSendMessage(emailModel);
    },

    onMessagesComplete() {
      this.$router.push('/messages/inbox');

    },

    setSubject() {
      if(this.replyingToMessage) {
        const subject = this.fields.subject;
        const newSubject = localStorage.getItem('messageSubject');
        newSubject.startsWith('Re:') ? subject.value = newSubject.trimLeft('Re:') : subject.value = `Re: ${newSubject}`;
        subject.readonly = true;
      }
    },

  },

  created() {
    this.requestContactById(localStorage.getItem('contactID'));
    this.setSubject();
  },

  beforeDestroy() {
    localStorage.removeItem('messageSubject');
    localStorage.removeItem('messageID');
    this.clearMessagingStore();
  },
};
</script>



// WEBPACK FOOTER //
// ComposeMessage.vue?a7377d46